import { throttle } from 'lodash';
import { gsap } from 'gsap';
import ScrollToPlugin from 'gsap/ScrollToPlugin';
import Flickity from 'flickity';
import 'flickity-imagesloaded';
import 'flickity-bg-lazyload';
import 'flickity-fade';
import 'flickity-as-nav-for';
import Masonry from 'masonry-layout';
import Isotope from 'isotope-layout';
import PhotoSwipe from 'photoswipe';
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default';
import asNavFor from 'flickity-as-nav-for';

const MOS = {};
window.MOS = MOS;
(() => {
  const gMapScript = 'https://maps.googleapis.com/maps/api/js?key=';
  const SCREENMDMAX = 1199;
  let winSize = 0;
  const calcWinSize = () => {
    winSize = { width: window.innerWidth, height: window.innerHeight };
  };
  const scrollTo = (elt, duration, target) => {
    console.log('scrollto', elt, duration, target);
    gsap.to(
      window,
      {
        duration: duration || 1,
        scrollTo: elt.getBoundingClientRect().top + window.scrollY,
        onComplete: () => {
          if (target !== undefined) {
            // window.location.hash = target;
          }
        },
      },
    );
  };

  const scrollToId = (href) => {
    if (href !== undefined) {
      const target = href.split('#')[1];
      if (document.getElementById(target) !== null) {
        scrollTo(document.getElementById(target), 1, target);
      }
    }
  };

  class Carousels {
    constructor(element) {
      if (element.querySelector('.js-carousel')) {
        console.log('Carousels::init', element.querySelectorAll('.js-carousel').length);
        const self = this;
        self.DOM = {
          elts: [],
          eltWrapper: element,
        };
        element.querySelectorAll('.js-carousel').forEach((elt) => {
          self.DOM.elts.push(elt);
        });
        self.flcks = [];
        self.init();
      }
    }
    init() {
      let idx = 0;
      const self = this;
      self.DOM.elts.forEach((instance) => {
        console.log('Carousels::init', idx);
        const flck = new Flickity(instance);
        if (self.DOM.eltWrapper.querySelector('.btn--next') && self.DOM.eltWrapper.querySelector('.btn--prev')) {
          self.DOM.eltWrapper.querySelector('.btn--next').addEventListener('click', (e) => {
            e.preventDefault();
            flck.next(true, false);
          });
          self.DOM.eltWrapper.querySelector('.btn--prev').addEventListener('click', (e) => {
            e.preventDefault();
            flck.previous(true, false);
          });
        }
        if (self.DOM.eltWrapper.querySelector('.c-carousel__info')) {
          self.DOM.infoItem = self.DOM.eltWrapper.querySelector('.c-carousel__info');
          self.DOM.infoItems = self.DOM.eltWrapper.querySelectorAll('.c-carousel__info-item');
          self.DOM.closeBtn = self.DOM.eltWrapper.querySelector('.btn-close');
          flck.on('change', self.onChange.bind(self));
          self.DOM.closeBtn.addEventListener('click', self.onClose.bind(self));
          self.isInfoClosed = false;
          if (winSize.width <= SCREENMDMAX) {
            self.onClose();
          }
        }
        self.flcks.push(flck);
        idx += 1;
      });
    }

    onChange(idx) {
      const self = this;
      console.log('info', this.DOM.infoItem, this.DOM.infoItems);
      self.DOM.infoItems.forEach((elt, index) => {
        if (index === idx) {
          elt.classList.add('is-active');
        } else {
          elt.classList.remove('is-active');
        }
      });
    }

    onClose() {
      const self = this;
      if (self.isInfoClosed) {
        self.DOM.infoItem.classList.add('is-opened');
        self.isInfoClosed = false;
      } else {
        self.DOM.infoItem.classList.remove('is-opened');
        self.isInfoClosed = true;
      }
    }
  }

  class DDMenuItem {
    constructor(elt) {
      this.DOM = { elt };
      this.DOM.btn = this.DOM.elt.querySelector('button');
      this.DOM.content = this.DOM.elt.querySelector('.menu-item__level');
      this.isOpen = this.DOM.elt.classList.contains('is-selected');
      this.init();
    }

    init() {
      const self = this;
      if (this.DOM.btn) {
        this.DOM.btn.addEventListener('click', self.toggleCurrent.bind(self));
      } else {
        console.log('MOSAIQUE:DDMenuItem missing button from menu__item--ddm');
      }
    }

    toggleCurrent() {
      if (this.isOpen) {
        this.hide();
      } else {
        this.show();
      }
    }
    show() {
      this.toggle('SHOW');
      this.isOpen = true;
    }
    hide() {
      this.toggle('HIDE');
      this.isOpen = false;
    }
    toggle(action) {
      if (action === 'SHOW') {
        gsap.to(this.DOM.content, { duration: 0.3, height: 'auto' });
        this.DOM.elt.classList.add('is-selected');
      } else {
        gsap.to(this.DOM.content, { duration: 0.3, height: 0 });
        this.DOM.elt.classList.remove('is-selected');
      }
    }
  }

  class MainNav {
    constructor(elt, eltWrapper) {
      if (document.querySelector(elt) && document.querySelector(eltWrapper)) {
        const self = this;
        self.DOM = { elt: document.querySelector(elt) };
        self.DOM.eltWrapper = document.querySelector(eltWrapper);
        self.settings = self.DOM.elt && self.DOM.elt.hasAttribute('data-settings') ? JSON.parse(self.DOM.elt.getAttribute('data-settings')) : {};
        self.DOM.openBtn = self.DOM.eltWrapper.querySelector('.btn-burger');
        self.DOM.closeBtn = self.DOM.eltWrapper.querySelector('.btn-close');
        this.DOM.menuLinks = this.DOM.elt.querySelectorAll('.menu__item a');
        self.isOpen = false;
        self.initEvents();
      }
    }
    initEvents() {
      const self = this;
      if (self.DOM.openBtn) {
        self.DOM.openBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          if (this.isOpen) {
            this.toggle('close');
          } else {
            this.toggle('open');
          }
        });
      }

      if (self.DOM.closeBtn) {
        self.DOM.closeBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.toggle('close');
        });
      }

      self.menuItems = [];
      Array.from(self.DOM.elt.querySelectorAll('.menu__item--ddm')).forEach(item => this.menuItems.push(new DDMenuItem(item)));

      if (self.settings.sticky !== undefined && self.settings.sticky && winSize.width > SCREENMDMAX) {
        window.addEventListener('scroll', throttle(self.onScroll.bind(self), 500, { leading: true, trailing: true }));
      }

      self.DOM.menuLinks.forEach((elt) => {
        elt.addEventListener('click', (e) => {
          const href = e.currentTarget.getAttribute('href');
          const target = href.split('#')[1];
          if (document.getElementById(target) !== null) {
            MOS.mainNav.close();
          }
        });
      });
    }

    toggle(action, _self) {
      const self = _self || this;
      self.isOpen = action === 'open';

      if (self.isOpen) {
        self.open();
      } else {
        self.close()
      }
    }

    open() {
      this.DOM.elt.classList.add('is-open');
      this.DOM.openBtn.classList.add('is-active');
      this.isOpen = true;
    }

    close() {
      this.DOM.elt.classList.remove('is-open');
      this.DOM.openBtn.classList.remove('is-active');
      this.isOpen = false;
    }

    onScroll(e) {
      const windowScrollY = window.scrollY;
      //200
      if (windowScrollY > 50) {
        this.DOM.elt.classList.add('is-sticky');
        this.DOM.isSticky = true;
      } else {
        this.DOM.elt.classList.remove('is-sticky');
        this.DOM.isSticky = false;
      }
      // console.log('StickyNav::scrolling', windowScrollY);
    }
  }

  class TabMenuItem {
    constructor(elt, panels, opts) {
      this.DOM = { elt };
      this.DOM.btn = this.DOM.elt.querySelector('button');
      this.DOM.panels = panels;
      this.isOpen = this.DOM.elt.classList.contains('is-active');
      this.opts = opts;
    }
    showHide(pos) {
      this.DOM.panels.forEach((item) => {
        console.log(parseInt(item.getAttribute("data-id"), 0))
        if (item.hasAttribute("data-id") && parseInt(item.getAttribute("data-id"), 0) !== pos) {
          item.classList.remove('is-active');
        } else {
          item.classList.add('is-active');
        }
      });
      this.DOM.btn.classList.add('is-active');
      this.isOpen = true;
    }

    toggle(action) {
      var self = this;
      if (action === 'SHOW') {
        gsap.to(self.DOM.content, { duration: 0.6, height: 'auto' });
        if (self.DOM.btn && self.opts.scrollTo === true) {
          scrollTo(self.DOM.btn, 1, null, 100);
        }
        self.DOM.elt.classList.add('is-active');
      } else {
        gsap.to(self.DOM.content, {
          duration: 0.4, height: 0, onComplete: () => {
            self.DOM.elt.classList.remove('is-active');
          }
        });
      }
    }

    reset() {
      this.DOM.btn.classList.remove('is-active');
      this.isOpen = false;
    }
  }

  class Tabs {
    constructor(elt) {
      const self = this;
      self.DOM = { elt };
      self.DOM.panels = self.DOM.elt.querySelectorAll('.c-tabs__panel');
      self.settings = self.DOM.elt.hasAttribute('data-tabs') ? JSON.parse(self.DOM.elt.getAttribute('data-tabs')) : {};
      self.menuItems = [];
      Array.from(self.DOM.elt.querySelectorAll('.c-tabs-menu__item')).forEach(item => self.menuItems.push(new TabMenuItem(item, self.DOM.panels, self.settings)));
      self.init();
      console.log("#Tabs--CTOR");
    }

    init() {
      this.current = 0;
      this.initEvents();
      if (typeof this.settings !== 'undefined' && 'autoOpen' in this.settings) {
        this.showContent(this.settings.autoOpen);
      }
    }

    initEvents() {
      for (const [pos, item] of this.menuItems.entries()) {
        if (item.DOM.btn) {
          item.DOM.btn.addEventListener('click', (e) => {
            e.preventDefault();
            this.showContent(pos);
          });
        }
      }
    }

    showContent(pos) {
      console.log('POS', pos);
      if (this.current !== pos) {
        this.menuItems[this.current].reset();
      }
      this.menuItems[pos].showHide(pos);
      this.current = pos;
    }
  }

  class MasonryGrid {
    constructor(elt) {
      this.DOM = { elt };
      this.init();
    }

    init() {
      const msnry = new Masonry(this.DOM.elt, {
        columnWidth: '.js-grid-sizer',
        itemSelector: '.js-masonry__item',
        percentPosition: true,
        stagger: 60,
      });
      this.loader = new ImagesLoaded(this.DOM.elt).on('progress', (instance, image) => {
        if (image.isLoaded) {
          msnry.layout();
        }
      });
      console.log("#MasonryGrid--INIT");
    }
  }

  class IsotopeGrid {
    constructor(eltWrapper) {
      this.DOM = { eltWrapper };
      this.DOM.elt = this.DOM.eltWrapper.querySelector('.js-isotope');
      this.settings = this.DOM.elt && this.DOM.elt.hasAttribute('data-settings') ? JSON.parse(this.DOM.elt.getAttribute('data-settings')) : {};
      this.init();
    }

    init() {
      const self = this;
      const opt = {};
      const iso = new Isotope(this.DOM.elt, {
        itemSelector: '.js-isotope-item',
        percentPosition: true,
        layoutMode: self.settings.layoutMode !== 'undefined' ? self.settings.layoutMode : 'masonry',
        gutter: 20
      });

      self.DOM.elt.addEventListener('load', () => {
        iso.layout();
      }, true);
      const filters = {};
      if (self.DOM.eltWrapper.querySelector('select')) {
        const filters = {};
        self.DOM.eltWrapper.querySelector('select').addEventListener('change', (e) => {
          const select = e.target;
          const filterGroup = select.getAttribute('data-filter-group');
          filters[filterGroup] = e.target.value;
          const filterValue = concatValues(filters);
          console.log(filterValue);
          iso.arrange({ filter: filterValue });
        });
      }
      console.log("#IsotopeGrid::init");
    }
  }

  class Gallery {
    constructor(elt) {
      const self = this;
      if (elt) {
        self.DOM = { elt };
        self.DOM.btns = self.DOM.elt.querySelectorAll('.js-gallery-btn');
        self.items = [];

        if (self.DOM.btns.length > 0) {
          self.initNested();
        } else {
          self.init();
        }
      }
    }

    init() {
      console.log('Gallery::init');
      var self = this;
      self.DOM.elt.querySelectorAll('figure').forEach((figure) => {
        const link = figure.querySelector('a');
        const item = {
          src: link.getAttribute('href'),
          w: link.getAttribute('data-width'),
          h: link.getAttribute('data-height'),
          title: link.getAttribute('data-caption')
        }
        self.items.push(item);
        link.addEventListener('click', (e) => {
          //[...self.DOM.elt.children].indexOf(e.currentTarget.parentElement),
          e.preventDefault();
          const pswp = document.querySelector('.pswp');
          const options = {
            index: e.currentTarget.getAttribute('data-id'),
            bgOpacity: 0.85,
            showHideOpacity: true
          };
          const gallery = new PhotoSwipe(pswp, PhotoSwipeUI_Default, self.items, options);
          gallery.init();
        })
      });
    }
    initNested() {
      console.log('Gallery::initNested');
      const self = this;
      self.DOM.btns.forEach((btn) => {
        btn.addEventListener('click', self.openGallery);
      });
    }
    openGallery() {
      console.log("Gallery::OPEN");
      var parseThumbnailElements = function (el) {
        var thumbElements = el.childNodes,
          numNodes = thumbElements.length,
          items = [],
          figureEl,
          linkEl,
          size,
          item;

        for (var i = 0; i < numNodes; i++) {
          figureEl = thumbElements[i]; // <figure> element
          // include only element nodes 
          if (figureEl.nodeType !== 1) {
            continue;
          }
          linkEl = figureEl.children[0]; // <a> element
          // create slide object
          item = {
            src: linkEl.getAttribute('href'),
            w: parseInt(linkEl.getAttribute('data-width'), 10),
            h: parseInt(linkEl.getAttribute('data-height'), 10)
          };

          if (figureEl.children.length > 1) {
            // <figcaption> content
            item.title = figureEl.children[1].innerHTML;
          }

          if (linkEl.children.length > 0) {
            // <img> thumbnail element, retrieving thumbnail url
            item.msrc = linkEl.children[0].getAttribute('src');
          }

          item.el = figureEl; // save link to element for getThumbBoundsFn
          items.push(item);
        }

        return items;
      };

      var pswpElement = document.querySelectorAll('.pswp')[0],
        gallery,
        options,
        items;

      var galleryElements = document.querySelectorAll('.' + this.getAttribute('id'))[0];
      items = parseThumbnailElements(galleryElements);

      // define options (if needed)
      var options = {
        index: 0 // start at first slide
      };


      var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
      gallery.init();
    }
  }

  class CookieConsent {
    constructor(elt) {
      this.DOM = { elt };
      this.DOM.closeBtn = this.DOM.elt.querySelector('#c-content-agree');
      this.isOpen = this.DOM.elt.classList.contains('is-active');
      this.settings = JSON.parse(this.DOM.elt.getAttribute('data-setting'));
      this.initEvents();
      if (this.settings.alwaysVisible) {
        this.show();
      } else {
        this.cookieHandler();
      }
    }

    initEvents() {
      this.DOM.closeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.hide();
        if (!this.settings.alwaysVisible) {
          this.constructor.setCookie(this.settings.id, this.settings.postedOn, 60);
          console.log('cookie set');
        }
      });
    }

    show() {
      this.toggle('SHOW');
      this.isOpen = true;
    }
    hide() {
      this.toggle('HIDE');
      this.isOpen = false;
    }

    toggle(action) {
      var self = this;
      if (action === 'SHOW') {
        gsap.to(self.DOM.elt, { duration: 0.6, height: 'auto' });
        self.DOM.elt.classList.add('is-active');
      } else {
        gsap.to(self.DOM.elt, {
          duration: 0.4, height: 0, onComplete: () => {
            self.DOM.elt.classList.remove('is-active');
          }
        });
      }
    }

    cookieHandler() {
      const cookie = this.constructor.getCookie(this.settings.id);
      if (cookie === '' || (cookie !== '' && cookie !== this.settings.postedOn)) {
        this.show();
      } else if (cookie !== '' && cookie === this.settings.postedOn) {
        this.hide();
      }
    }

    static setCookie(id, value, expiryDays) {
      let date = new Date();
      date.setTime(date.getTime() + (expiryDays * 24 * 60 * 60 * 1000));
      const expires = "expires=" + date.toUTCString();
      document.cookie = `${id}= ${value}; ${expires}; path=/`;
    }

    static getCookie(cname) {
      const name = `${cname}=`;
      const decodedCookie = decodeURIComponent(document.cookie);
      const ca = decodedCookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
          return c.substring(name.length, c.length);
        }
      }
      return '';
    }
  }

  MOS.GMap = {
    load: () => {
      if (typeof MOS.GMap.isLoaded === 'undefined') {
        const self = MOS.GMap;
        MOS.GMap.isLoaded = false;
        self.isLoaded = false;
        self.DOM = {
          elt: document.getElementById('gmap'),
          zoomInBtn: document.getElementById('gmap-zoom-in'),
          zoomOutBtn: document.getElementById('gmap-zoom-out'),
        };
        self.settings = JSON.parse(self.DOM.elt.getAttribute('data-settings'));
        self.marker = self.settings.marker;
        self.locations = self.settings.locations;
        self.zoom = parseInt(self.settings.zoom, 0) || 14;
        self.apiKey = self.DOM.elt.getAttribute('data-gmapkey');
        self.markers = [];
        const script = document.createElement('script');
        script.addEventListener('load', MOS.GMap.loaded);
        script.src = `${gMapScript + self.apiKey}&callback=window.MOS.GMap.init`;
        document.body.appendChild(script);
      } else {
        MOS.GMap.loaded();
        MOS.GMap.init();
      }
    },
    loaded: () => {
      MOS.GMap.isLoaded = true;
    },
    init: () => {
      if (google.maps) {
        console.log('MOS.GMap::init');
        const self = MOS.GMap;
        let marker;
        const center = {
          lng: parseFloat(self.locations[0].lng),
          lat: parseFloat(self.locations[0].lat),
        };

        self.styles = {
        };

        const theme = (self.settings.theme !== 'undefined' && self.settings.theme === 'dark') ? self.styles.dark : self.styles.light;
        self.map = self.createMap(self.DOM.elt, center, self.zoom, theme);
        self.locations.forEach((location, index) => {
          const id = index;
          marker = MOS.GMap.createMarker(
            self.map,
            location.id,
            location.title,
            location.description,
            location.url,
            location.lng,
            location.lat,
            location.marker,
          );
          google.maps.event.addListener(marker, 'click', () => {
            self.onMarkerClicked(self.map, self.markers[id].marker);
            self.map.setZoom(self.zoom);
          });
          self.markers.push({ id: location.id, marker });
        });
        self.initEvents();

        if (self.locations.length == 1) {
          self.map.setZoom(self.zoom);
        } else if (MOS.Util.hasTouchScreen() && winSize.width > SCREEN_SM_MAX) {
          console.log('GMAP::autocenter...');
          self.autoCenter(self.map);
        }
      }
    },
    initEvents: () => {
      const self = MOS.GMap;
      if (self.DOM.zoomInBtn) {
        google.maps.event.addDomListener(self.DOM.zoomInBtn, 'click', () => {
          const currentZoomLevel = self.map.getZoom();
          if (currentZoomLevel !== 21) {
            self.map.setZoom(currentZoomLevel + 1);
          }
        });
      }

      if (self.DOM.zoomInBtn) {
        google.maps.event.addDomListener(self.DOM.zoomOutBtn, 'click', () => {
          const currentZoomLevel = self.map.getZoom();
          if (currentZoomLevel !== 0) {
            self.map.setZoom(currentZoomLevel - 1);
          }
        });
      }
    },
    createMarker: (map, id, title, body, url, lng, lat, markerIco) => {
      return new google.maps.Marker({
        position: { lat: parseFloat(lat), lng: parseFloat(lng) },
        id: id || parseInt(Math.random() * 10000, 0),
        map,
        title: title || '',
        body: body || '',
        icon: markerIco || 'img/map-marker.png',
        animation: google.maps.Animation.DROP,
      });
    },
    createMap: (elt, coordinates, zoom, style) => {
      return new google.maps.Map(document.getElementById('gmap'), {
        zoom: zoom || 4,
        center: coordinates,
        disableDefaultUI: true,
        styles: style,
      });
    },
    onMarkerClicked: (map, marker) => {
      const infoWindow = new google.maps.InfoWindow({
        content: `<div class="map__info-panel"><h3 class="normal">${marker.title}</h3><p class="small">${marker.body}</p></div>`,
        maxWidth: 300,
      });
      infoWindow.open(map, marker);
    },
    autoCenter(map) {
      console.info('GMAP::autocenter');
      const bounds = new google.maps.LatLngBounds();
      MOS.GMap.markers.forEach((m) => {
        bounds.extend(m.marker.position);
      });
      map.fitBounds(bounds);
      map.panToBounds(bounds);
    },
  };

  const concatValues = (obj) => {
    let value = '';
    for (let prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        value += obj[prop];
      }
    }
    return value;
  }

  function initEvents() {

  }

  function init() {
    let idx = 0;
    MOS.scrollPlugin = ScrollToPlugin;
    gsap.registerPlugin(ScrollToPlugin);
    MOS.mainNav = new MainNav('.c-main-nav', '.c-main-nav__wrapper');
    if (document.querySelectorAll('.c-tabs')) {
      MOS.tabs = [];
      document.querySelectorAll('.c-tabs').forEach((element) => {
        MOS.tabs.push(new Tabs(element));
      });
    }

    // hijack link with anchors & scroll to
    document.querySelectorAll('a[href^="#"]').forEach((elt) => {
      elt.addEventListener('click', (e) => {
        e.preventDefault();
        const href = e.currentTarget.getAttribute('href');
        if (href !== undefined) {
          const target = href.split('#')[1];
          if (document.getElementById(target) !== null) {
            scrollTo(document.getElementById(target));
          }
        }
      });
    });

    if (document.querySelector('.validation-summary-errors')) {
      scrollTo(document.querySelector('.validation-summary-errors'));
    }

    if (document.querySelector('.validation-summary-success')) {
      scrollTo(document.querySelector('.validation-summary-success'));
    }


    if (document.querySelector('.js-carousel-wrapper')) {
      MOS.carousels = [];
      document.querySelectorAll('.js-carousel-wrapper').forEach((element) => {
        MOS.carousels.push(new Carousels(element));
      });
    }

    if (document.querySelector('.js-isotope')) {
      MOS.isotopes = [];
      idx = 0;
      document.querySelectorAll('.js-isotope-wrapper').forEach((eltWrapper) => {
        const isotope = new IsotopeGrid(eltWrapper);
        MOS.isotopes.push({ id: `isotope${idx}`, isotope });
        idx += 1;
      });
    }

    if (document.querySelector('.js-gallery')) {
      MOS.galleries = [];
      idx = 0;
      document.querySelectorAll('.js-gallery').forEach((elt) => {
        const gallery = new Gallery(elt);
        MOS.galleries.push({ id: `gallery${idx}`, gallery });
        idx += 1;
      });
    }

    if (document.getElementById('gmap')) {
      MOS.GMap.load();
    }

    if (document.querySelector('.c-consent')) {
      MOS.consent = new CookieConsent(document.querySelector('.c-consent'));
    }

    initEvents();
  }

  document.addEventListener('DOMContentLoaded', () => {
    calcWinSize();
    init();
  });
})();